















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { client } from '../shared';
import { redirect, Routes } from '../shared/router';
import { ResetPassword } from '../shared/user';
import {
    required,
    minLength,
    between,
    email,
    decimal,
    integer,
    url,
    sameAs,
    alphaNum,
} from 'vuelidate/lib/validators';
@Component({
    components: {},
})
export default class Reset extends Vue {
    $v: any;
    form: any = {
        resetPasswordToken: null,
        userName: null,
        password: null,
        confirmPassword: null,
    };
    @Validations()
    validations: any = {
        form: {
            resetPasswordToken: {
                required,
            },
            userName: {
                required,
            },
            password: {
                required,
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('password'),
            },
        },
    };
    async created() {
        try {
            const r = await client.get(
                new ResetPassword({ resetPasswordToken: this.$route.params.id }),
            );
            Object.assign(this.form, r);
        } catch (error) {
            this.$swal(
                'Password Reset',
                'The forgot password link has expired.',
                'error',
            ).then(() => {
                redirect(Routes.Home);
            });
        }
    }
    async submit() {
        try {
            const r = await client.post(
                new ResetPassword({
                    resetPasswordToken: this.form.resetPasswordToken,
                    userName: this.form.userName,
                    newPassword: this.form.password,
                    confirmPassword: this.form.confirmPassword,
                }),
            );

            this.$swal(
                'Password Updated',
                'You may now use your new password to login.',
                'success',
            ).then(() => {
                redirect(Routes.SignIn);
            });
        } catch (error) {
            this.$swal(
                'Password Reset',
                'The forgot password link has expired.',
                'error',
            ).then(() => {
                redirect(Routes.Home);
            });
        }
    }
}
